import { OrderStopTable } from "../OrderStopTable";
import { StopEntry } from "../StopEntry";
import { Button, DataSource, Image, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutManageStops extends Layout {
    buttonCancel: Button;
    buttonInsertStop: Button;
    imageInstructionalAdd: Image;
    imageInstructionalHamburger: Image;
    labelControlTitle: Label;
    labelInstructions1: Label;
    labelInstructions2: Label;
    labelInstructions3: Label;
    layoutOrderStopTable: OrderStopTable;
    layoutStopEntry: StopEntry;
    panelControlButtons: Panel;
    panelOrderStops: Panel;
    panelStopControls: Panel;
    panelStopEntry: Panel;
    sourceStop: DataSource;
}
